import React from "react";

const services = [
  {
    title: "Managed IT Services",
    description: "Proactive monitoring and maintenance of your systems to ensure uptime and performance.",
  },
  {
    title: "Network Security",
    description: "Secure your infrastructure with the latest in firewall and anti-threat technology.",
  },
  {
    title: "IT Consulting",
    description: "Get expert advice and strategic planning for your tech initiatives and challenges.",
  },
  {
    title: "Desktop Services",
    description: "Everyday desktop support. We have over 20 years of experience repairing desktops and laptops. We understand that having functional machines is essential to your business. It is our priority to ensure your machines are running 24 x 7."
  },
  {
    title: "Wireless Services",
    description: "Both companies and individuals can easily be confused on what the best wireless setup is for them. if it’s managing a corporate account, procuring wireless hardware or setting up a basic family plan. our team of experts can help you drive down your costs while ensuring you have the optimal setup"
  },
  {
    title: "Cloud Services",
    description: "Cloud computing is a popular buzz word in today’s technology world. Cloud computing could help both individual families with multiple computers who like to share content with their family and friends. Or for small businesses looking to reduce costs while leveraging new technologies to enable mobility."
  }
];

export default function Services() {
  return (
    <section className="bg-white py-20" id="services">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-12">Our Services</h2>
        <h3 className="text-2xl md:text-3xl text-neutral-800 mb-11">Easy, Fast, Affordable</h3>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-neutral-100 hover:bg-neutral-200 transition p-6 rounded-xl shadow-md"
            >
              <h3 className="text-xl font-semibold text-neutral-800 mb-4">
                {service.title}
              </h3>
              <p className="text-neutral-600 text-sm">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
